import { ManageEntitlement } from './src/manage-entitlement';
import { ManageEntitlementV2 } from './src/manage-entitlement-v2';

import { useFeatureToggle } from '@css-xp/base';
import { ENABLE_MANAGE_SUBSCRIPTION_BULK_EDIT } from '@atlassian/cssxp-utils-generic';
import React from 'react';

export const ManageEntitlementPane = (props: any) => {
  const [isEnabled] = useFeatureToggle();
  const isBulkEditEnabled = isEnabled(ENABLE_MANAGE_SUBSCRIPTION_BULK_EDIT);

  if (isBulkEditEnabled) return <ManageEntitlementV2 {...props} />;
  return <ManageEntitlement {...props} />;
};
